<div class="modal-backdrop" *ngIf="isOpen" (click)="onBackdropClick($event)">
  <div class="modal-container">
    <div class="modal-header">
      <h2>File Upload</h2>
      <button 
        class="close-btn" 
        (click)="close()" 
        [disabled]="isUploading"
        aria-label="Close modal"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <div class="modal-body">
      <div class="file-input-wrapper">
        <input 
          type="file" 
          id="fileInput"
          (change)="onFileSelected($event)"
          [disabled]="isUploading"
          accept="image/*"
          #fileInput
        />
        <label for="fileInput" class="file-label">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" *ngIf="!selectedFile">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
            <polyline points="17 8 12 3 7 8"></polyline>
            <line x1="12" y1="3" x2="12" y2="15"></line>
          </svg>
          <span class="file-label-text" *ngIf="!selectedFile">Choose File</span>
          <span class="file-label-text selected" *ngIf="selectedFile">{{ selectedFile.name }}</span>
        </label>
      </div>

      <div *ngIf="selectedFile && !uploadComplete" class="file-info">
        <div class="file-info-row">
          <span class="label">File:</span>
          <span class="value">{{ selectedFile.name }}</span>
        </div>
        <div class="file-info-row">
          <span class="label">Size:</span>
          <span class="value">{{ formatBytes(selectedFile.size) }}</span>
        </div>
      </div>

      <button 
        *ngIf="selectedFile && !uploadComplete"
        (click)="uploadFile()" 
        [disabled]="isUploading"
        class="upload-btn"
      >
        <span *ngIf="!isUploading">Upload File</span>
        <span *ngIf="isUploading">Uploading...</span>
      </button>

      <div *ngIf="isUploading || uploadComplete" class="progress-container">
        <div class="progress-bar">
          <div 
            class="progress-fill" 
            [style.width.%]="uploadProgress"
          ></div>
        </div>
        <p class="progress-text">
          {{ uploadProgress }}% - {{ formatBytes(uploadedBytes) }} / {{ formatBytes(totalBytes) }}
        </p>
      </div>

      <div *ngIf="uploadComplete" class="success-message">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
          <polyline points="22 4 12 14.01 9 11.01"></polyline>
        </svg>
        <p>Upload Complete!</p>
      </div>

      <div *ngIf="uploadError" class="error-message">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
        <p>{{ uploadError }}</p>
      </div>
    </div>
  </div>
</div>
